import { createContext } from 'react';
import { IPortionPositionItem } from 'types';

export type TChangePortionPositionSelectedRestaurant = { id: string; name: string };
export type TTypeOfChangePortionPositionModalWindow =
	| null
	| 'toConfirmFieldsClearing'
	| 'toConfirmSave'
	| 'success'
	| 'error';

export interface IChangePortionPositionState {
	IDSelectedCustomer: Nullable<string>;
	selectedRestaurant: Nullable<TChangePortionPositionSelectedRestaurant>;
	IDSelectedDish: Nullable<string>;
	positionsData: IPortionPositionItem[];
	typeOfModalWindow: TTypeOfChangePortionPositionModalWindow;
	isVisibleAdditionalRestaurantsModal: boolean;
	isApplyToOne: boolean;
	selectedAdditionalRestaurants: TChangePortionPositionSelectedRestaurant[];
	selectSearchString: string;
}

export const changePortionPositionInitialState: IChangePortionPositionState = {
	IDSelectedCustomer: null,
	selectedRestaurant: null,
	IDSelectedDish: null,
	positionsData: [],
	typeOfModalWindow: null,
	isVisibleAdditionalRestaurantsModal: false,
	isApplyToOne: false,
	selectedAdditionalRestaurants: [],
	selectSearchString: '',
};

export interface IChangePortionPositionContext extends IChangePortionPositionState {
	setIDCustomer(value: Nullable<string>): void;
	setRestaurant(value: Nullable<TChangePortionPositionSelectedRestaurant>): void;
	setIDDish(value: Nullable<string>): void;
	resetSelectedControls(): void;
	setPositionsData(data: IPortionPositionItem[]): void;
	reorderItems(value: IPortionPositionItem[]): void;
	changeTypeOfModalWindow(value: TTypeOfChangePortionPositionModalWindow): void;
	setVisibleAdditionalRestaurantsModal(value: boolean): void;
	toggleApplyToOne(): void;
	setAdditionalRestaurants(value: TChangePortionPositionSelectedRestaurant[]): void;
	changeSelectSearchString(value: string): void;
}

export const ChangePortionPositionContext = createContext<IChangePortionPositionContext>({
	setIDCustomer: () => undefined,
	setRestaurant: () => undefined,
	setIDDish: () => undefined,
	resetSelectedControls: () => undefined,
	setPositionsData: () => undefined,
	reorderItems: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	setVisibleAdditionalRestaurantsModal: () => undefined,
	toggleApplyToOne: () => undefined,
	setAdditionalRestaurants: () => undefined,
	changeSelectSearchString: () => undefined,
	...changePortionPositionInitialState,
});
